import { MODAL_ANIMATION_DURATION, ModalContext, ModalProvider } from './Provider'

export { ModalProvider, ModalContext, MODAL_ANIMATION_DURATION }
export { IModalComponentProps, IModalContextProps } from './Provider'
